import axios from 'axios';
import { SEALOS_HOSPITAL_API_URL } from './baseUrls';

const url = SEALOS_HOSPITAL_API_URL;

// 上传图片的请求函数
export const uploadImage = async (userData) => {
    try {
        const response = await axios.post(`${url}/patient`, userData);
        return response.data; // 返回响应数据
    } catch (error) {
        throw error.response.data; // 抛出错误信息
    }
};


// 删除图片的请求函数
export const deleteImage = async (userData) => {
    try {
        const response = await axios.post(`${url}/patient`, userData);
        return response.data; // 返回响应数据
    } catch (error) {
        throw error.response.data; // 抛出错误信息
    }
};

// getwechatsignature获取微信签名的请求函数
export const getwechatsignature = async (query) => {
    try {
        const response = await axios.get(`${url}/weixin`, query);
        return response.data; // 返回响应数据
    } catch (error) {
        throw error.response.data; // 抛出错误信息
    }
};

// getwechatsignature获取微信签名的请求函数
export const getwechatImage = async (serverId) => {
    try {
        const response = await axios.post(`${url}/weixin`,  {
            postflag: 'getwechatimage',
            serverId:serverId
        });
        return response.data; // 返回响应数据
    } catch (error) {
        throw error.response.data; // 抛出错误信息
    }
};
